import {BasicController, BasicSmartfoxConstants, EnvGlobalsHandler} from "@goodgamestudios/core";
import { BasicModel } from "@goodgamestudios/core";
import { IEnvironmentGlobals } from "@goodgamestudios/core";
import { SimpleCommand } from "@goodgamestudios/core";
import { classImplementsInterfaces } from "@goodgamestudios/createjs-utilities";
import { Poker2Model } from "../../model/Poker2Model";

export class Poker2LoginCommand extends SimpleCommand {
    public execute(commandVars: any = null): void {
        var paramsObject: any;

        if (this.env.pln == "" || this.env.sig == "") {
            paramsObject = { nameOrMail: Poker2Model.userData.userName, connectMillis: BasicModel.smartfoxClient.connectionTime };
            BasicController.getInstance().loginJson(paramsObject);
        }
    }

    private get env(): IEnvironmentGlobals {
        return EnvGlobalsHandler.globals;
    }
}
classImplementsInterfaces(Poker2LoginCommand, "ISimpleCommand");
